(() => {
  const configuration = document.getElementById('YioraCleanProductImages');
  if (!configuration) return;
  const replacements = JSON.parse(configuration.textContent);
  const attributes = ['src', 'srcset', 'data-src', 'data-srcset', 'data-image', 'href', 'style'];
  const selector = 'img, source, [data-src], [data-image], [style*="background"], a[href]';

  function replacementFor(value) {
    if (!value || value.startsWith('data:')) return null;
    try {
      const url = new URL(value, document.baseURI);
      const filename = decodeURIComponent(url.pathname.split('/').pop());
      const originalFilename = filename.replace(/_(?:\d+x\d*|\d*x\d+|small|medium|large|thumb|compact|grande)(?:_crop_[a-z]+)?(?=\.[^.]+$)/i, '');
      return replacements[filename] || replacements[originalFilename] || null;
    } catch {
      return null;
    }
  }

  function sourceSetReplacement(value) {
    if (!value) return null;
    for (const candidate of value.split(',')) {
      const replacement = replacementFor(candidate.trim().split(/\s+/)[0]);
      if (replacement) return replacement;
    }
    return null;
  }

  function rewrite(element) {
    if (!(element instanceof Element)) return;
    if (element.tagName === 'IMG' || element.tagName === 'SOURCE') {
      const replacement = replacementFor(element.getAttribute('src'))
        || replacementFor(element.getAttribute('data-src'))
        || sourceSetReplacement(element.getAttribute('srcset'))
        || sourceSetReplacement(element.getAttribute('data-srcset'));
      if (replacement) {
        if (element.tagName === 'IMG') element.setAttribute('src', replacement);
        if (element.hasAttribute('srcset') || element.tagName === 'SOURCE') element.setAttribute('srcset', replacement);
        if (element.hasAttribute('data-src')) element.setAttribute('data-src', replacement);
        if (element.hasAttribute('data-srcset')) element.setAttribute('data-srcset', replacement);
      }
    }
    for (const attribute of ['data-image', 'href']) {
      const replacement = replacementFor(element.getAttribute(attribute));
      if (replacement) element.setAttribute(attribute, replacement);
    }
    const style = element.getAttribute('style');
    if (style && style.includes('url(')) {
      const cleanStyle = style.replace(/url\(\s*(['"]?)(.*?)\1\s*\)/g, (original, quote, url) => {
        const replacement = replacementFor(url);
        return replacement ? `url("${replacement}")` : original;
      });
      if (cleanStyle !== style) element.setAttribute('style', cleanStyle);
    }
  }

  function scan(root) {
    rewrite(root);
    root.querySelectorAll?.(selector).forEach(rewrite);
  }

  scan(document);
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes') rewrite(mutation.target);
      else mutation.addedNodes.forEach(scan);
    }
  }).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: attributes });
})();
